import React, { Component } from 'react';
import { Col, Label, Input, FormGroup } from "reactstrap";
import _ from 'lodash';
import { somenteNumeros } from '../../../utils/formatar';

export default class FormInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            alerta: this.props.alerta,
            value: ""
        };
    }

    componentDidMount() {
        setTimeout(() => {
            if (_.get(this.props.objeto, this.props.dado, 0) !== null) {
                this.setState({
                    value: _.get(this.props.objeto, this.props.dado)
                })
            }
        }, 100);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.alerta !== this.props.alerta) {
            this.setState({
                alerta: this.props.alerta
            });
        }
    };

    handleChange = (e) => {
        this.props.onChange(e, e);
        const value = somenteNumeros(e.target.value)

        if (value !== this.state.value) {
            let valorValido = true;

            if (!this.props.permiteValorNegativo) {
                valorValido = (value >= 0);
            }

            if (valorValido) {
                if (this.props.limiteMaximo) {
                    if (value.length <= this.props.limiteMaximo) {
                        this.setState({ value })
                    }
                } else {
                    this.setState({ value })
                }
            }
        }
    }
    //mudarEstadoDoOnMouseOver
    handlePaste = e => {
        const value = somenteNumeros(e.clipboardData.getData('Text'))
        this.setState({ value })
        e.preventDefault()
    }

    handleBlur = (event) => {
        var invalido = (this.props.validador) ? this.props.validador(event.target.value) : false;
        if (!invalido) {
            this.salva(event);
            this.props.validacaoStore && this.props.validacaoStore(true)
        }
        if (invalido && this.props.validacaoStore) {
            this.props.validacaoStore(false)
        }
        this.setState({
            alerta: invalido
        });
    }

    salva = (event) => {
        this.props.onChange(event, event)
        if (this.props.onBlur) {
            this.props.onBlur(_.get(this.props.objeto, this.props.dado));
        }
    }

    render() {
        return (
            <Col className={`${this.props.className ? this.props.className : ""} ${this.props.col ? this.props.col : ""}`}
                xs={this.props.xs ? this.props.xs : 'auto'}
                sm={this.props.sm ? this.props.sm : 'auto'}
                md={!this.props.col && this.props.md ? this.props.md : 'auto'}>
                <FormGroup
                onMouseOver={this.props.renderizarTexto? this.props.renderizarTexto : ''}
                onMouseLeave={this.props.tirarTextoDaTela? this.props.tirarTextoDaTela : ''}
                >
                    
                    {
                    this.props.titulo && <Label 
                    //onMouseOver={this.props.renderizarTexto? this.props.renderizarTexto : ''}
                    > {this.props.titulo} {this.props.obrigatorio ? <span className="label-danger">*</span> : ""} </Label>}
                    <Input defaultValue= { this.props.value ? this.props.value : _.get(this.props.objeto, this.props.dado) }
                        value={this.state.value ? this.state.value : _.get(this.props.objeto, this.props.dado)}
                        className={this.props.uppercase ? 'uppercase' : ''}
                        disabled={this.props.bloqueado ? "disabled" : ""}
                        type="text"
                        min={this.props.min ? this.props.min : 0} max={this.props.max ? this.props.max : 999999}
                        onChange={this.handleChange}
                        maxLength={this.props.limiteMaximo}
                        onBlur={(event) => this.handleBlur(event, event)}
                        onPaste={this.handlePaste}
                        
                        
                    />
                </FormGroup>
                {(this.props.labelStatus && this.props.labelStatus.length > 0) ? <Label className="label-danger">{this.props.labelStatus}</Label> : ""}
                {this.state.alerta
                    && <Col xs={12} className="col-label label-obrigatorio px-0">
                        <Label>{this.state.alerta}</Label>
                    </Col>
                }
            </Col>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/FormInputNumber.js